<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- <div class="row">
        <div class="col-sm-8">
            <b-form-select @change="getAllSubs()" v-model="selectedStatus" :options="payoutStatus" class="mb-3" />
        </div>
    </div> -->
    <div v-if="nSubs" class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Card Sales</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="nSubs"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              ></b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import firebase from 'firebase/app';

export default {
    page: {
    title: "Card Sales",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
      components: {
    Layout,
    PageHeader,
  },
  data(){
      return {
          title: "Card Sales",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Card Sales",
          active: true,
        },
      ],
      fields: [
        {
          key: "amount",
          sortable: true,
        },
        {
          key: "feeAmount",
          sortable: true,
        },
        {
          key: "feePercent",
          sortable: true,
        },
        {
          key: "invoiceNumber",
          sortable: true,
        },
        {
          key: "lastFour",
          sortable: true,
        },
        {
          key: "country",
          sortable: true,
        },
        {
          key: "storeName",
          sortable: true,
        },
        {
          key: "status",
          sortable: true,
        },
        {
          key: "created",
          sortable: true,
        },
      ],
      options: {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
      },
      nSubs: [],
      sortBy: "",
      sortDesc: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      pageOptions: [10, 25, 50, 100],
      isLoading: false,
      fullPage: true,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      filter: null,
      filterOn: [],
      }
  },
  methods: {
      onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getAllSubs(){
        this.nSubs = [];
      await firebase.firestore().collection("cardSale").orderBy("created", "desc").limit(50)
    //   .where("status", "==", this.selectedStatus)
      .get().then((dataList)=>{
        // eslint-disable-next-line no-console
                        // console.log(this.selectedStatus);
        if(dataList.size > 0){
          var itemArray = [];
          dataList.docs.forEach((singleDoc)=>{
            var amount = singleDoc.data().amount ? singleDoc.data().amount.toFixed(2): 0;
            var dCurrency = singleDoc.data().defaultCurrency ?? "";
            var data = {
              id: singleDoc.id,
              created: singleDoc.data().created.toDate().toLocaleDateString("en-US", this.options),
              amount: amount+" "+dCurrency,
              feeAmount: singleDoc.data().feeAmount ? singleDoc.data().feeAmount.toFixed(2) : 0,
              invoiceNumber: singleDoc.data().invoiceNumber,
              lastFour: singleDoc.data().lastFour,
              status: singleDoc.data().status,
              storeId: singleDoc.data().storeId,
              storeName: singleDoc.data().storeName,
              userId: singleDoc.data().userId,
              country: singleDoc.data().country ?? "No set",
              feePercent: singleDoc.data().feePercent.toString()+"%",
              defaultCurrency: singleDoc.data().defaultCurrency ?? ""
            }
            itemArray.push(data);
            this.nSubs = itemArray
          })
        }
      })
    }
  },
  computed: {
      rows() {
      return this.nSubs.length;
    },
  },
  mounted() {
    this.getAllSubs();
  },
}
</script>

<style>

</style>